import { getZona } from '../config-paginas';
import { getBajaToAltaX, getBajaToAltaY } from '../config-libro';

var bajaToAltaCoordenadas = function bajaToAltaCoordenadas(state, libroId, paramCoordenadas) {
  var bajaToAltaX = getBajaToAltaX(state, libroId);
  var bajaToAltaY = getBajaToAltaY(state, libroId); // coordenadas poligonales => array de puntos

  if (esPoligonal(paramCoordenadas)) {
    return paramCoordenadas.split(':').map(function (paramPunto) {
      var _paramPunto$split$map = paramPunto.split(',').map(Number),
          x = _paramPunto$split$map[0],
          y = _paramPunto$split$map[1];

      return [bajaToAltaX(x), bajaToAltaY(y)];
    });
  }

  var _paramCoordenadas$spl = paramCoordenadas.split(',').map(Number),
      x = _paramCoordenadas$spl[0],
      y = _paramCoordenadas$spl[1],
      w = _paramCoordenadas$spl[2],
      h = _paramCoordenadas$spl[3]; // coordenadas rectangulares => array de puntos


  x = bajaToAltaX(x);
  y = bajaToAltaY(y);
  w = bajaToAltaX(w);
  h = bajaToAltaY(h);
  return [[x, y], [x + w, y], [x + w, y + h], [x, y + h]];
};

var srcImagenAlta = function srcImagenAlta(pagina) {
  return 'contenido/' + pagina + '.png';
};

var esPoligonal = function esPoligonal(param) {
  return param.includes(':');
};

export var getContenidoTipoZoom = function getContenidoTipoZoom(state, zona) {
  var vinculo = zona.vinculo;

  var _vinculo$split = vinculo.split(','),
      pagina = _vinculo$split[1],
      coordenadas = _vinculo$split.slice(2); // es referencia a otra zona


  var libroId = pagina.substring(0, 2);
  var numPagina = Number(pagina.substring(2, 5));
  var numZona = zona.numZona;

  if (coordenadas.length === 1) {
    numZona = Number(coordenadas[0]);
    var zonaReferenciada = getZona(state, libroId, numPagina, numZona); // const zonasPagina = getZona(state, libroId, numPagina)
    // const zonaReferenciada = zonasPagina[numZonaReferenciada - 1]

    coordenadas[0] = zonaReferenciada.boton;
  }

  var coordenadasAlta = bajaToAltaCoordenadas(state, libroId, coordenadas.join(','));
  var contenido = {
    // id: zona.id,
    tipo: 'zoom',
    libroId: libroId,
    numPagina: numPagina,
    numZona: numZona,
    imagen: srcImagenAlta(pagina),
    coordenadasOriginales: coordenadas[0],
    coordenadas: coordenadasAlta
  };
  return contenido;
};
export var getContenidoTipoZoomBoton = function getContenidoTipoZoomBoton(state, boton) {
  var vinculo = boton.vinculo;

  var _vinculo$split2 = vinculo.split(','),
      libroIdYPagina = _vinculo$split2[1],
      coordenadas = _vinculo$split2.slice(2); // es referencia a otra zona


  var libroId = libroIdYPagina.substring(0, 2);
  var numPagina = Number(libroIdYPagina.substring(2, 5));

  if (coordenadas.length === 1) {
    var numZona = Number(coordenadas[0]);
    var zonaReferenciada = getZona(state, libroId, numPagina, numZona); // const zonasPagina = getZona(state, libroId, numPagina)
    // const zonaReferenciada = zonasPagina[numZonaReferenciada - 1]

    coordenadas = zonaReferenciada.boton.split(",");
  }

  var coordenadasAlta = bajaToAltaCoordenadas(state, libroId, coordenadas.join(','));
  var contenido = {
    // id: zona.id,
    tipo: 'zoom',
    libroId: libroId,
    numPagina: numPagina,
    // numZona,
    imagen: srcImagenAlta(libroIdYPagina),
    coordenadas: coordenadasAlta
  };
  return contenido;
};